"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _utils = require("../utils");
var _endpoints = require("../constants/endpoints");
// This will simply take in some information and decide whether to mutate via POST or via PUT
const useMutateModConfigEntry = _ref => {
  let {
    configName,
    moduleName,
    id
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const queryClient = (0, _reactQuery.useQueryClient)();
  const baseNamespace = (0, _utils.modConfigEntriesQueryKey)({
    configName,
    moduleName
  });
  const putQueryObject = (0, _reactQuery.useMutation)([...baseNamespace, 'putConfigEntry', id], async data => ky.put(`${_endpoints.MOD_SETTINGS_ENDPOINT}/${id}`, {
    json: data
  }).json().then(() => {
    queryClient.invalidateQueries(baseNamespace);
  }));
  const postQueryObject = (0, _reactQuery.useMutation)([...baseNamespace, 'postConfigEntry'], async data => ky.post(`${_endpoints.MOD_SETTINGS_ENDPOINT}`, {
    json: data
  }).json().then(() => {
    queryClient.invalidateQueries(baseNamespace);
  }));
  if (id) {
    return putQueryObject;
  }
  return postQueryObject;
};
var _default = exports.default = useMutateModConfigEntry;